import { State, Action, StateContext, Selector } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { UserStateSettingsService } from 'src/core/services/state/user-state-settings.service';
import { GenericState } from '../generic/generic.state';
import { CategoryStateModel } from 'src/core/models/category/category.state-model';
import { FilterChange, GroupByChange, SorterChange } from 'src/core/actions/category/category.actions';
const name = 'CategoryState';
@State<CategoryStateModel>({
  name: name,
  defaults: {
    filters: null,
    sort: null,
    currentPage: 0,
    selectedGroupId: {},
  } as CategoryStateModel,
})
@Injectable()
export class CategoryState extends GenericState<CategoryState> {
  @Selector()
  static getFilter(state: CategoryStateModel): any {
    return state.filters;
  }

  @Selector()
  static getSortField(state: CategoryStateModel): string {
    var a = state.sort == null ? 'CreationTime' : state.sort.active;
    return a;
  }

  @Selector()
  static getSortDirection(state: CategoryStateModel): 'asc' | 'desc' | '' {
    return state.sort == null ? 'desc' : state.sort.direction;
  }

  @Action(FilterChange)
  changeFilter(ctx: StateContext<CategoryStateModel>, action: FilterChange) {
    const currentState = ctx.getState();
    if (!currentState.filters) {
      currentState.filters = {};
    }
    currentState.filters = action.filters;
    this.userSettingsService.patchState(ctx, currentState, name);
  }

  @Action(SorterChange)
  changeSorter(ctx: StateContext<CategoryStateModel>, action: SorterChange) {
    const currentState = ctx.getState();

    currentState.sort = action.sort;
    this.userSettingsService.patchState(ctx, currentState, name);
  }

  @Action(GroupByChange)
  changeGroupBy(ctx: StateContext<CategoryStateModel>, action: GroupByChange) {
    const currentState = ctx.getState();
    // Defensive guard: legacy persisted state may still have the old flat
    // (number) shape for selectedGroupId — reset to a map before writing.
    if (typeof currentState.selectedGroupId !== 'object' || currentState.selectedGroupId === null) {
      currentState.selectedGroupId = {};
    }
    currentState.selectedGroupId[action.key] = action.selectedGroupId;
    this.userSettingsService.patchState(ctx, currentState, name);
  }

  constructor(userSettingsService: UserStateSettingsService) {
    super(userSettingsService);
    this.name = name;

    this.userSettingsService.register(this.name, this);
  }
}
